"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setDefaultsFromContext = setDefaultsFromContext;
exports.installAuthInterceptor = installAuthInterceptor;
exports.removeAuthInterceptor = removeAuthInterceptor;
exports.makeApiService = makeApiService;
exports.makeMockedApiService = makeMockedApiService;
exports.transformResponse = exports.ApiClient = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _axios = _interopRequireDefault(require("axios"));

var _camelcaseKeys = _interopRequireDefault(require("camelcase-keys"));

var _config = _interopRequireDefault(require("next/config"));

var _snakecaseKeys = _interopRequireDefault(require("snakecase-keys"));

var _api = require("../../helpers/api");

var _defaults = require("../defaults");

var _onAuthFail = require("./onAuthFail");

var _getConfig = (0, _config["default"])(),
    API_BASE_URL_CLIENT = _getConfig.publicRuntimeConfig.API_BASE_URL_CLIENT,
    API_BASE_URL_SERVER = _getConfig.serverRuntimeConfig.API_BASE_URL_SERVER;
/* -------------------------------------------------------------------------- */

/*                               Axios instance                               */

/* -------------------------------------------------------------------------- */

/**
 *
 * @deprecated use makeApiService
 * This applies only to methods .get, .post, .patch, .put, and .delete
 * Know more at: https://gitlab.com/remote-com/employ-starbase/tracker/-/issues/2635
 */


var ApiClient = _axios["default"].create({
  baseURL: process.browser ? API_BASE_URL_CLIENT : API_BASE_URL_SERVER,
  withCredentials: true
});

exports.ApiClient = ApiClient;

function setDefaultsFromContext() {
  var _context$req;

  var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  // Provide cookies to axios headers. Same as withCredentials on the browser
  var _ref = (context === null || context === void 0 ? void 0 : (_context$req = context.req) === null || _context$req === void 0 ? void 0 : _context$req.headers) || {},
      cookie = _ref.cookie;

  if (cookie) {
    ApiClient.defaults.headers.common.Cookie = cookie;
  } else {
    delete ApiClient.defaults.headers.common.Cookie;
  }
}
/* -------------------------------------------------------------------------- */

/*                               Interceptors                                 */

/* -------------------------------------------------------------------------- */


var interceptorReference = null;

function installAuthInterceptor() {
  if (interceptorReference === null) {
    interceptorReference = ApiClient.interceptors.response.use(function (resp) {
      return resp;
    }, _onAuthFail.onAuthFail);
  }
}

function removeAuthInterceptor() {
  ApiClient.interceptors.response.eject(interceptorReference);
  interceptorReference = null;
}

var _transformResponse = function transformResponse(rawResponse, deepTransformResponse) {
  var response = (0, _camelcaseKeys["default"])(JSON.parse(rawResponse), {
    deep: deepTransformResponse
  });
  return response !== null && response !== void 0 && response.data ? response.data : response;
};
/**
 * API Service factory.
 *
 * Factory function aimed to simplify and unify service creation and service parameters.
 *
 * We would also remove one nested `data` property,
 * so that the response data would be located at the root level of the response.
 *
 * Example:
 * const filesService = = makeApiService({ path: '/files' })
 *
 * ...
 * const { data, status } = await filesService({ queryParams: { ... }});
 *
 * data.files → [...]
 * data.totalPages →  4;
 * status → 200
 *
 * @param {object} serviceConfiguration
 * API endpoint that contains params in square brackets. E.g. files/[fileSlug]
 * @param {string} serviceConfiguration.path
 * HTTP Method (get, post, put, delete, patch)
 * @param {string} serviceConfiguration.method
 * @returns {function} ApiService function
 */


exports.transformResponse = _transformResponse;

function makeApiService(serviceConfiguration) {
  var path = serviceConfiguration.path,
      _serviceConfiguration = serviceConfiguration.method,
      method = _serviceConfiguration === void 0 ? 'get' : _serviceConfiguration,
      _serviceConfiguration2 = serviceConfiguration.asFormData,
      asFormData = _serviceConfiguration2 === void 0 ? true : _serviceConfiguration2,
      _serviceConfiguration3 = serviceConfiguration.deepTransformResponse,
      deepTransformResponse = _serviceConfiguration3 === void 0 ? true : _serviceConfiguration3,
      _serviceConfiguration4 = serviceConfiguration.isAdminEndpoint,
      isAdminEndpoint = _serviceConfiguration4 === void 0 ? false : _serviceConfiguration4;
  return /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
    var requestConfig,
        pathParams,
        queryParams,
        bodyParams,
        url,
        prefix,
        axiosRequestConfig,
        _args = arguments;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            requestConfig = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};
            pathParams = requestConfig.pathParams, queryParams = requestConfig.queryParams, bodyParams = requestConfig.bodyParams;
            url = path.replace(/\[(.*?)\]/g, function (_, $1) {
              return pathParams[$1];
            });
            prefix = isAdminEndpoint ? _defaults.adminV1ApiEndpoint : _defaults.V1ApiEndpoint;
            axiosRequestConfig = {
              method: method,
              url: "".concat(prefix).concat(url),
              transformResponse: function transformResponse(rawResponse) {
                return _transformResponse(rawResponse, deepTransformResponse);
              }
            };

            if (queryParams) {
              axiosRequestConfig.params = (0, _snakecaseKeys["default"])(queryParams);
            }

            if (bodyParams) {
              // for initial implementation, we would encode every single
              // body in FormData. In some cases this might be conditional,
              // so feel free to add this if you need it.
              axiosRequestConfig.data = asFormData ? (0, _api.getParamsAsFormData)(bodyParams) : (0, _snakecaseKeys["default"])(bodyParams);
            }

            return _context.abrupt("return", ApiClient.request(axiosRequestConfig));

          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
}
/**
 * Similar API to the makeApiService, this function allows creating mocked versions of the APIs, which is
 * handy while backend API is still in development.
 * @param {*} _
 * @param {*} mockResponse
 * @returns
 */


function makeMockedApiService(_, mockResponse) {
  return function () {
    return new Promise(function (resolve) {
      setTimeout(function () {
        return resolve(mockResponse);
      }, 200);
    });
  };
}